import { generateExperienceCheckoutTicket } from 'lib/checkout/experiences/cart'
import uuidV4 from 'lib/string/uuidV4Utils'

export function replaceTicketsByFareType(item: App.Checkout.ExperienceItem, timeslot: App.ExperienceAvailabilityTimeSlot): App.Checkout.ExperienceItem {
  const fixedTickets = item.tickets.map(cartTicket => {
    let ticket = timeslot.tickets.find(t => t.id === cartTicket.ticketId)
    if (!ticket && cartTicket.fareType) {
      ticket = timeslot.tickets.find(t => t.fareType === cartTicket.fareType)
    }
    if (!ticket) { return cartTicket }
    return generateExperienceCheckoutTicket({ ticket, count: cartTicket.count })
  })

  return { ...item, tickets: fixedTickets }
}

export function fillItemKeyAndTransactionKey(item: App.Checkout.AnyItem) {
  return {
    ...item,
    itemId: item.itemId ?? uuidV4(),
    transactionKey: item.transactionKey ?? uuidV4(),
  }
}

export function getRestoreCartUriForId(cartId: string) {
  return `/checkout-restore-cart?cartId=${encodeURIComponent(cartId)}`
}
